import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {SortHeaderWithDataTable} from '@pb/kit-component-sort-header';

import {HEADERS} from '../constants';
import {
    ssoAccountsStateActions,
    ssoAccountsStateSelector,
} from '../services/sso-accounts-state.slice';

import type {DraftSortField} from 'src/openapi/admin/models/DraftSortField';
import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

type Props = {
    columnId: string,
    sortField: DraftSortField,
};

export const SsoAccountsSortHeader = ({columnId, sortField}: Props) => {
    const dispatch = useDispatch();
    const cacheKeys = useSelector(ssoAccountsStateSelector);

    const sort = useCallback((direction: 'ASC' | 'DESC') => {
        dispatch(ssoAccountsStateActions.setSortCriteria({
            direction: direction as SortDirection,
            field: sortField,
        }));
    }, [dispatch, sortField]);

    return (
        <SortHeaderWithDataTable
            defaultDirection={SortDirections.ASC}
            direction={cacheKeys.sortCriteria.field === sortField
                ? cacheKeys.sortCriteria.direction
                : null}
            filterActive={true}
            caption={HEADERS[columnId]}
            onSort={sort}
        />
    );
};
